export default {"src":"/_next/static/media/arrow-right-grey-inline.9b80a800.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};